import { connect } from 'react-redux';

import MakePage from '../../components/Seo/MakePage';

function mapStateToProps({ search_form: { locations, makes, models } }) {
  return { locations, makes, models };
}

export default connect(mapStateToProps)(MakePage);
